import { invokeEdgeFunction } from '../lib/edgeFunctions'

// Toda la administración de usuarios pasa por la Edge Function cp-admin-usuarios,
// que valida el permiso gestionar_usuarios con el JWT de la sesión. El navegador
// nunca envía roles ni permisos como autorización.
const callAdminUsuarios = (body) => invokeEdgeFunction('cp-admin-usuarios', body)

export async function puedeGestionarUsuarios() {
  const data = await callAdminUsuarios({ action: 'permisos' })
  return data?.gestionar_usuarios === true
}

export async function listarUsuarios() {
  const data = await callAdminUsuarios({ action: 'listar' })
  return data.usuarios ?? []
}

export async function crearUsuarioDirectiva(email, passwordTemporal) {
  const data = await callAdminUsuarios({ action: 'crear', email, password: passwordTemporal })
  return data.usuario
}

export function cambiarEstadoUsuario(usuarioId, activo) {
  return callAdminUsuarios({ action: 'cambiar_estado', usuario_id: usuarioId, activo })
}

// La contraseña es temporal: el backend marca debe_cambiar_clave = true.
export function restablecerPasswordUsuario(usuarioId, passwordTemporal) {
  return callAdminUsuarios({ action: 'restablecer_password', usuario_id: usuarioId, password: passwordTemporal })
}

// Cambio obligatorio de la propia contraseña temporal. La identidad sale del JWT;
// solo se envía la nueva contraseña.
export function cambiarClaveInicial(nuevaPassword) {
  return invokeEdgeFunction('cp-cambiar-clave-inicial', { nueva_password: nuevaPassword })
}
